module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/152/assets/images/903a54f9a912b96b3fb05c94240ccb6c.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_pencil.svg
// module id = /T4H
// module chunks = 1